import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['input', 'dropzone', 'thumbnail', 'preview', 'emptyState'];

  highlight(event) {
    event.preventDefault();
    this.dropzoneTarget.classList.add('border-black-300', 'bg-black-50');
  }

  unhighlight(event) {
    event.preventDefault();
    this.dropzoneTarget.classList.remove('border-black-300', 'bg-black-50');
  }

  handleDrop(event) {
    event.preventDefault();
    this.unhighlight(event);

    const files = Array.from(event.dataTransfer.files);
    if (files.length === 0) return;

    this.inputTarget.files = event.dataTransfer.files;
    this._previewFile(files[0]);
  }

  handleChoose(event) {
    const file = event.target.files[0];
    if (file) {
      this._previewFile(file);
    }
  }

  triggerReplace() {
    this.inputTarget.click();
  }

  stopPropagation(event) {
    event.stopPropagation();
  }

  _previewFile(file) {
    const reader = new FileReader();
    reader.onload = () => {
      this.thumbnailTarget.src = reader.result;
      this._showPreview();
    };
    reader.readAsDataURL(file);
  }

  _showPreview() {
    this.previewTarget.classList.remove('hidden');
    this.dropzoneTarget.classList.add('hidden');
  }

  _clearPreview() {
    this.previewTarget.classList.add('hidden');
    this.dropzoneTarget.classList.remove('hidden');
    if (this.thumbnailTarget) {
      this.thumbnailTarget.src = '#';
    }
  }
}
